import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { computed } from "mobx";
import Result from "../../Core/Result";
import Trait from "../Trait";
export default function anyTrait(options) {
  return function (target, propertyKey) {
    const constructor = target.constructor;
    if (!constructor.traits) {
      constructor.traits = {};
    }
    constructor.traits[propertyKey] = new AnyTrait(propertyKey, options, constructor);
  };
}
export class AnyTrait extends Trait {
  constructor() {
    super(...arguments);
    _defineProperty(this, "decoratorForFlattened", computed.struct);
  }
  getValue(model) {
    for (const stratum of model.strataTopToBottom.values()) {
      const stratumAny = stratum;
      if (stratumAny !== undefined && stratumAny[this.id] !== undefined) {
        return stratumAny[this.id];
      }
    }
    return undefined;
  }
  fromJson(_model, _stratumName, jsonValue) {
    return new Result(jsonValue);
  }
  toJson(value) {
    return value;
  }
  isSameType(trait) {
    return trait instanceof AnyTrait;
  }
}